import o from"styled-components";import{theme as e}from"../../../../../theme.js";import{FieldContainer as t}from"../Field.styles.js";const i=o(t)`
  min-height: 56px;
  height: fit-content;
  align-items: start;
  padding: ${e.spacing*2}px;
`,n=o.textarea`
  font-size: 16px;
  color: ${e.colors.gray[900]};
  resize: none;
  padding: 0;
  outline: none;
  border: none;
  line-height: 24px;
  &::placeholder {
    font-size: 16px;
    color: ${e.colors.gray[400]};
  }
`;export{i as StyledFieldContainer,n as StyledTextArea};
